import React, { useEffect } from 'react';
import styled from 'styled-components';
import { NamedColorsHEX } from '../util/styles';
import { Spinner } from './Spinner';

const ScLoading = styled.div`
  background-color: ${NamedColorsHEX.PantoneCanoliCream}AA;
  bottom: 0;
  display: flex;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;
  justify-content: center;
  align-items: center;
`;

export const FullscreenSpinner = ({ show = false }: { show: boolean }) => {
  useEffect(() => {
    const body = document.body;
    if (show) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = '';
    }

    return () => {
      body.style.overflow = '';
    };
  }, [show]);
  if (!show) {
    return null;
  }
  return (
    <ScLoading>
      <Spinner />
    </ScLoading>
  );
};
